import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useStore } from "@/store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/app/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
  },
  {
    path: "/app/resources",
    name: "resources",
    component: () =>
      import(/* webpackChunkName: "resources" */ "../views/ResourcesView.vue"),
  },
  {
    path: "/app/resources_details/:title",
    name: "resources_detail",
    component: () =>
      import(
        /* webpackChunkName: "resources_detail" */ "../views/ResourcesDetailView.vue"
      ),
    props: true,
  },
  {
    path: "/app/video_view/:id",
    name: "video_view",
    component: () =>
      import(/* webpackChunkName: "video_view" */ "../views/VideoView.vue"),
    props: true,
  },
  {
    path: "/app/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/users/LoginView.vue"),
    meta: { allowAnonymous: true },
  },
  {
    path: "/app/password-reset",
    name: "password_reset",
    component: () =>
      import(
        /* webpackChunkName: "password_reset" */ "../views/users/PasswordResetView.vue"
      ),
    meta: { allowAnonymous: true },
  },
  {
    path: "/app/password-reset/:uidb64/:token",
    name: "password_reset_confirm",
    component: () =>
      import(
        /* webpackChunkName: "password_reset_confirm" */ "../views/users/PasswordResetConfirmView.vue"
      ),
    meta: { allowAnonymous: true },
    props: true,
  },
  {
    path: "/app/password-setup",
    name: "password_setup",
    component: () =>
      import(
        /* webpackChunkName: "password_setup" */ "../views/users/PasswordSetupView.vue"
      ),
    meta: { allowAnonymous: true },
  },
  {
    path: "/app/password-setup/:uidb64/:token",
    name: "password_setup_confirm",
    component: () =>
      import(
        /* webpackChunkName: "password_setup_confirm" */ "../views/users/PasswordSetupConfirmView.vue"
      ),
    meta: { allowAnonymous: true },
    props: true,
  },
  {
    path: "/app/logout",
    name: "logout",
    component: () =>
      import(/* webpackChunkName: "logout" */ "../views/users/LogoutView.vue"),
  },
  {
    path: "/app/account",
    name: "account",
    component: () =>
      import(
        /* webpackChunkName: "account" */ "../views/users/AccountView.vue"
      ),
  },
  {
    path: "/app/password-change",
    name: "password_change",
    component: () =>
      import(
        /* webpackChunkName: "password_change" */ "../views/users/PasswordChangeView.vue"
      ),
  },
  {
    path: "/app/user/:userId",
    name: "user_profile",
    component: () =>
      import(
        /* webpackChunkName: "user_profile" */ "../views/users/ProfileView.vue"
      ),
    props: true,
  },
  //Positive Experiences
  {
    path: "/app/positive_experiences/",
    name: "positive_experiences",
    component: () =>
      import(
        /* webpackChunkName: "positive_experiences" */ "../views/positive_experiences/IndexView.vue"
      ),
  },
  {
    path: "/app/positive_experience_form/:experienceId?",
    name: "positive_experience_form",
    component: () =>
      import(
        /* webpackChunkName: "positive_experience_form" */ "../views/positive_experiences/FormView.vue"
      ),
    props: true,
  },

  // Check-Ins
  {
    path: "/app/check_ins/",
    name: "check_ins",
    component: () =>
      import(
        /* webpackChunkName: "check_ins" */ "../views/check_ins/IndexView.vue"
      ),
  },
  {
    path: "/app/check_ins/locations/:locationId",
    name: "check_ins_location",
    component: () =>
      import(
        /* webpackChunkName: "check_ins_location" */ "../views/check_ins/LocationView.vue"
      ),
    props: true,
  },
  {
    path: "/app/check_ins/locations/:locationId/students/:studentId",
    name: "check_ins_location_student",
    component: () =>
      import(
        /* webpackChunkName: "check_ins_location_student" */ "../views/check_ins/StudentView.vue"
      ),
    props: true,
  },
  {
    path: "/app/check_ins/locations/:locationId/students/:studentId?/form",
    name: "check_ins_location_student_form",
    component: () =>
      import(
        /* webpackChunkName: "check_ins_location_student_form" */ "../views/check_ins/StudentFormView.vue"
      ),
    props: true,
  },
  {
    path: "/app/check_ins/locations/:locationId/students/:studentId/check-ins/:checkInId?/form",
    name: "check_ins_check_in_form",
    component: () =>
      import(
        /* webpackChunkName: "check_ins_check_in_form" */ "../views/check_ins/CheckInForm.vue"
      ),
    props: true,
  },
  {
    path: "/app/student_checkin/locations/:locationId/:organizationId",
    name: "student_checkin",
    component: () =>
      import(
        /* webpackChunkName: "student_checkin" */ "../views/student_checkin/IndexView.vue"
      ),
    props: true,
    meta: { allowAnonymous: true },
  },
  {
    path: "/app/student_checkin/check_ins/locations/:locationId/:organizationId/students/form",
    name: "kiosk_student_checkin",
    component: () =>
      import(
        /* webpackChunkName: "kiosk_student_checkin" */ "../views/student_checkin/CheckInForm.vue"
      ),
    props: true,
    meta: { allowAnonymous: true },
  },
  {
    path: "/app/student_checkin/check_outs/locations/:locationId/:organizationId/students/form",
    name: "kiosk_student_checkout",
    component: () =>
      import(
        /* webpackChunkName: "kiosk_student_checkout" */ "../views/student_checkin/CheckOutForm.vue"
      ),
    props: true,
    meta: { allowAnonymous: true },
  },
  // Administrators
  {
    path: "/app/administrators",
    name: "administrators",
    component: () =>
      import(
        /* webpackChunkName: "administrators" */ "../views/administrators/IndexView.vue"
      ),
    props: true,
  },
  {
    path: "/app/administrators/locations/:locationId?/form",
    name: "administrators_location_form",
    component: () =>
      import(
        /* webpackChunkName: "administrators_location_form" */ "../views/administrators/FormView.vue"
      ),
    props: true,
  },
  {
    path: "/app/administrators/locations/:locationId",
    name: "administrators_location",
    component: () =>
      import(
        /* webpackChunkName: "administrators_location" */ "../views/administrators/LocationView.vue"
      ),
    props: true,
  },
  {
    path: "/app/administrators/locations/:locationId/:userType/users/:userId?/form",
    name: "administrators_location_user_form",
    component: () =>
      import(
        /* webpackChunkName: "administrators_location_user_form" */ "../views/administrators/UserFormView.vue"
      ),
    props: true,
  },
  //Coping tools
  {
    path: "/app/coping_tools",
    name: "coping_tools",
    component: () =>
      import(
        /* webpackChunkName: "coping_tools" */ "../views/coping_tools/IndexView.vue"
      ),
    props: true,
  },
  {
    path: "/app/coping_tools/locations/:locationId",
    name: "coping_tools_location",
    component: () =>
      import(
        /* webpackChunkName: "coping_tools_location" */ "../views/coping_tools/LocationView.vue"
      ),
    props: true,
  },
  {
    path: "/app/coping_tools/locations/:locationId/form/:toolId?/:toolName?",
    name: "coping_tools_form",
    component: () =>
      import(
        /* webpackChunkName: "coping_tools_form" */ "../views/coping_tools/FormView.vue"
      ),
    props: true,
  },
  // Zoom
  {
    path: "/app/zoom",
    name: "zoom",
    component: () =>
      import(/* webpackChunkName: "zoom" */ "../views/zoom/IndexView.vue"),
  },

  // Reports
  {
    path: "/app/reports",
    name: "reports",
    component: () =>
      import(
        /* webpackChunkName: "reports" */ "../views/reports/IndexView.vue"
      ),
    props: true,
  },

  {
    path: "/:catchAll(.*)",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/PageNotFoundView.vue"),
    meta: { allowAnonymous: true },
  },
];

const scrollPositions = Object(null);

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.path && scrollPositions[to.path] !== undefined) {
      document.documentElement.scrollTop = scrollPositions[to.path];
    } else {
      document.documentElement.scrollTop = 0;
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const store = useStore();

  store.latestFromRoute = from;
  const appNotLaunched = document.querySelector(".app-not-launched");

  if (appNotLaunched) {
    await new Promise<void>((resolve) => {
      const observer = new MutationObserver(() => {
        observer.disconnect();
        resolve();
      });

      observer.observe(appNotLaunched, { attributes: true });
    });
  }

  if (
    to.matched.some((record) => record.meta.allowAnonymous) ||
    store.loggedIn
  ) {
    if (from.path) {
      scrollPositions[from.path] = document.documentElement.scrollTop;
    }
    next();
  } else {
    next({
      name: "login",
      query: { next: to.fullPath },
    });
  }
});

export default router;
